import React, {useState, useEffect, useCallback, useRef} from 'react';
import {
    Container,
    Button,
    Grid,
    CircularProgress,
    TextField,
  
} from '@mui/material';
import { Alert } from '@mui/material';
import {Link as RouterLink, useParams, useHistory } from 'react-router-dom';
import {useForm, Controller} from 'react-hook-form';
import {
    GrantAccountStatementService
} from '../shared/service';
import ValidationError from "../../shared/ValidationError";
import {DataGrid} from "@mui/x-data-grid";
import {Check, Send} from "react-feather";

import {focalPersonColumnModel, recipientColumnModel} from './table-models';
import Link from "@mui/material/Link";
import EmailPreview from "./email-preview";
import ValidateFile from "./validate-file";
import Prompt from "../../../customUtil/Prompt";
const GrantAccountStatementForm = () => {
    const methods = useForm();
    const {handleSubmit, control, setValue, errors} = methods;    
    const [data, setData] = useState({});
    const [peopleIds, setPeopleIds] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
    const [allFocalPointsSelected, setAllFocalPointsSelected] = useState(false);
    const [allPrContactsSelected, setAllPrContactsSelected] = useState(false);
    const [showProvideFile, setShowProvideFile] = useState(false);
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isReady, setIsReady] = useState(false);
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
      const [isVisibleDialog, setVisibleDialog] = useState(false);

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );
      
      useEffect(() => {
       
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);
   
    // Do this everytime the period changes.
    useEffect(() => {
        if (id !== "new") {
            GrantAccountStatementService.getById(id).then((response) => {
                setData(response.data);
                setIsReady(true);
            });
        } else {
            setData({gasCountry: {countryPeople: []}, emailTemplate: {}, language: {}});
            setIsReady(true);
        }
    }, [id, setValue]);
  

    useEffect(() => {
        if (data.allEmailPeople) {
            setPeopleIds(data.allEmailPeople.map(e => e.id))
        }
    }, [data])

    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        const request = {
            ...data, ...d,
            status: d.status ? d.status : {id: 1}
        }
        if (data.id) {
            GrantAccountStatementService
                .update(request)
                .then((response) => {
                    if (!response.error) {
                        setData(response.data);
                        setMessage('Grant Account Statement Detail updated.');
                    } else {
                        setErrorMessage("There was an error saving the grant account statement.")
                    }
                });
        }
    };

    const reload = () => {
        GrantAccountStatementService.getById(id).then((response) => {
            setData(response.data);
            setIsReady(true);
        });
    }

    const checkIfIncluded = (id) => {
        return peopleIds.includes(id);
    }

    const validateEmails = () => {
        onSubmit({...data, emailsValidated: true});
    }


    const addAll = (row) => {
        let newEmailPeople = data.emailPeople;
            newEmailPeople.push({person: row});

        let newAllPeople = data.allEmailPeople;
            newAllPeople.push(row);
        setData({...data, emailPeople: newEmailPeople, allEmailPeople: newAllPeople})
    }

    const removeAll = (rows) => {
        let newEmailPeople = data.emailPeople;
        let newAllPeople = data.allEmailPeople;
        rows.forEach(row => {
            newEmailPeople = newEmailPeople.filter(p => p.person.id !== row.id);
            newAllPeople = newAllPeople.filter(p => p.id !== row.id);
        });
        setData({...data, emailPeople: newEmailPeople, allEmailPeople: newAllPeople})
    }

    const toggleSelectAllFocalPoints = () => {
        if (!allFocalPointsSelected) {
            data.grantDetail.gasCountry.countryPeople
                .forEach((p) => addAll(p.person, !allFocalPointsSelected))
        } else {
            removeAll(data.grantDetail.gasCountry.countryPeople.map(p => p.person));
        }

        setAllFocalPointsSelected(!allFocalPointsSelected);
    }

    const toggleSelectAllPRs = () => {
        if (allPrContactsSelected) {
            removeAll(data.grantDetail.principalRecipient.programContacts.map(p=>p.contact))
        } else {
            data.grantDetail.principalRecipient.programContacts.forEach((p) => addAll(p.contact, !allPrContactsSelected))
        }

        setAllPrContactsSelected(!allPrContactsSelected);
    }

    const onCheckedChanged = (row) => {
        let newEmailPeople = data.emailPeople;
        if (checkIfIncluded(row.id)) {
            newEmailPeople = newEmailPeople.filter(p => p.person.id !== row.id);
        } else {
            newEmailPeople.push({person: row});
        }
        let newAllPeople = data.allEmailPeople;
        if (checkIfIncluded(row.id)) {
            newAllPeople = newAllPeople.filter(p => p.id !== row.id);
        } else {
            newAllPeople.push(row);
        }

        setData({...data, emailPeople: newEmailPeople, allEmailPeople: newAllPeople})
    }

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }

  
    const triggerSubmit = () => {
      refSubmitButtom?.current?.click();
    };     
 
    const onSave = (event) => {
        console.log(event)
        triggerSubmit();
        setBlock(false);
        setVisibleDialog(false);
    }

    const checkModified = (event) => {
        if(event.type ===  "change"){
            setBlock(true);
               }
            }

    return (
        <Container>
            <header>
                <h1>Grant Account Statement Distribution</h1>
            </header>
            {
                message && <Alert severity="success">{message}</Alert>
            }
            {
                errorMessage && <Alert severity="error">{errorMessage}</Alert>
            }
   
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <p>
                            Grant Account Statement.
                        </p>
                    </Grid>

                    <Grid item xs={6}>
                        <Controller
                            name="grantName"
                            control={control}
                            fullWidth
                            as={<TextField/>}
                            label="Name"
                            disabled
                            color="primary"
                            variant="outlined"
                            rules={{required: 'Name is required.'}}
                            defaultValue={data.grantDetail.grantName}
                        />
                        <ValidationError error={errors.grantName}/>
                    </Grid>
                    <Grid item xs={6}>
                        <Controller
                            name="gasCountry"
                            control={control}
                            fullWidth
                            label="Country"
                            as={<TextField/>}
                            color="primary"
                            disabled
                            variant="outlined"
                            defaultValue={data.grantDetail.gasCountry && data.grantDetail.gasCountry.name}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Controller
                            name="language"
                            fullWidth
                            control={control}
                            label="Language"
                            color="primary"
                            as={<TextField/>}
                            disabled
                            variant="outlined"
                            defaultValue={data.grantDetail.language && data.grantDetail.language.name}
                        />
                    </Grid>

                    <Grid item xs={6}>

                        <Controller
                            name="emailTemplate"
                            control={control}
                            label="Email Template"
                            fullWidth
                            color="primary"
                            as={<TextField/>}
                            disabled
                            variant="outlined"
                            defaultValue={data.grantDetail.emailTemplate && data.grantDetail.emailTemplate.templateName}
                        />
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={12}>
                        {
                            data.gasFound && data.gasReportFile &&
                            <>
                                GAS file: <a target="_blank" rel="noreferrer"
                                             href={data.gasReportFile.documentLocation}>{data.gasReportFile.documentName}</a>
                            </>
                        }
                        {
                            !data.gasFound &&
                            <Alert severity="error">The gas file associated with this period and grant combination is
                                not found.
                                You can upload the GAS file to the google drive folder and try again.
                                Or <Link component={RouterLink} onClick={() => setShowProvideFile(true)}>click
                                    here</Link> to
                                provide
                                a direct link to the GAS file for this Grant and Period combination.
                            </Alert>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        Focal People in Country
                        <DataGrid
                            rowHeight={35}
                            autoHeight={true}
                            rows={data.grantDetail.gasCountry ? data.grantDetail.gasCountry.countryPeople : []}
                            columns={focalPersonColumnModel(checkIfIncluded, onCheckedChanged, toggleSelectAllFocalPoints, allFocalPointsSelected)}
                            pageSize={20}/>
                    </Grid>
                    {
                        data.grantDetail.principalRecipient &&
                        <Grid item xs={12}>
                            Principal Recipient Contacts
                            <DataGrid
                                rowHeight={35}
                                autoHeight={true}
                                rows={data.grantDetail.principalRecipient && data.grantDetail.principalRecipient.programContacts ? data.grantDetail.principalRecipient.programContacts : []}
                                columns={recipientColumnModel(checkIfIncluded, onCheckedChanged, toggleSelectAllPRs, allPrContactsSelected)}
                                pageSize={20}/>
                        </Grid>
                    }
                    <Grid item xs={12}>
                        <Button variant="contained" color="primary" type="submit">Save</Button>
                        &nbsp;{!data.emailsValidated &&
                    <Button disabled={data.grantDetail.emailPeople.length === 0} variant="contained" color="secondary"
                            onClick={() => validateEmails()}>Validate Emails</Button>
                    }
                        {
                            data.emailsValidated &&
                            <Button disabled color="secondary" variant="contained"><Check color="green"/>Email Validated</Button>
                        }
                        &nbsp;
                        <Button disabled={!data.gasFound || !data.emailsValidated} color="primary" variant="contained"
                                onClick={() => setShowPreview(true)}> <Send/> Send Email</Button>
                    </Grid>
                </Grid>
                <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
            <EmailPreview data={data} open={showPreview} handleClose={() => {
                setShowPreview(false);
                reload();
            }}/>
            <ValidateFile data={data} open={showProvideFile} handleClose={() => {
                setShowProvideFile(false);
                reload();
            }}/>
        </Container>
    );
};

export default GrantAccountStatementForm;
